import { Components } from '.generated/templates/Feature.Components.model';
import { Routes } from '.generated/templates/Project.Routes.model';
import { Sitecore } from '.generated/templates/_.Sitecore.Override';
import EditingHelpText, { MissingDataSource } from 'components/helpers/EditingHelpText';
import { classnames } from 'tailwindcss-classnames';
import ArticlePageCard from 'components/helpers/Cards/article-page-card';
import EventPageCard from 'components/helpers/Cards/event-page-card';
import GenericPageCard from 'components/helpers/Cards/generic-page-card';
import Container from 'components/helpers/Container';
import { Core } from '.generated/templates/Foundation.Core.model';
import { isArticlePage, isEventPage } from 'lib/sitecore';

export type PageCardProps = Sitecore.Override.ComponentBase &
  Components.General.PageCard.Fields.PageCard;
export type GenericPage = Sitecore.Override.ItemEx & Routes.Fields.GenericPage;

const PageCard = (props: PageCardProps): JSX.Element => {
  const { fields } = props;
  // Fail out if we don't have any fields
  if (!fields) {
    return <MissingDataSource />;
  }

  let output;
  if (!fields.promotedPage) {
    return <EditingHelpText text="Page Card | No Promoted page Selected in datasource. " />;
  }

  const promotedPage = fields.promotedPage as Sitecore.Override.ItemEx &
    Core.BaseTemplates.Routes.Fields.BasePage;

  // Event Page
  if (isEventPage(fields.promotedPage)) {
    output = (
      <>
        <EventPageCard promotedPage={promotedPage} pageCard={props} isSingleCard />
      </>
    );
  } else if (isArticlePage(fields.promotedPage)) {
    output = (
      <>
        <ArticlePageCard promotedPage={promotedPage} pageCard={props} isSingleCard />
      </>
    );
  } else {
    output = (
      <>
        <GenericPageCard promotedPage={promotedPage} pageCard={props} isSingleCard />
      </>
    );
  }

  return (
    <Container
      size="standard"
      className={classnames('callout-card-container', 'mb-8')}
      dataComponent="authorable/general/pagecard"
    >
      {output}
    </Container>
  );
};

export default PageCard;
